export enum LoadOption {
    None,
    Default,
    Custom,
    All,
}
